<td>{{article.variation_id}}</td>
<td>{{article.vendor_article_id}}</td>
<td>{{article.article_name}}</td>
<td>{{article.article_name_order}}</td>
<td>{{article.unit}}</td>
@for (field of fields; track field) {
  <td [ngClass]="{'align-right': field.isValueType('Number')}">
    @if (!(article.fields[field.html_name]|isNull)) {
      @switch (field.data_type) {
        @case ('Option') {
      <i class="fa" [ngClass]="{
          'fa-check':(article.fields[field.html_name] === true),
          'fa-times': (article.fields[field.html_name] === false)}"></i>
        }
        @case ('Ganzzahl') {
          {{ article.fields[field.html_name] | money:0 }}
        }
        @case ('Kommazahl') {
          {{ article.fields[field.html_name] | money:3 }}
        }
        @default {
          {{ article.fields[field.html_name] }}
        }
      }
    }
  </td>
}
<td class="align-right">{{article.amount|money}}</td>
<td class="align-right">{{article.amount_ordered|money}}</td>
<td class="align-right">{{article.min_stock|money}}</td>
<td class="align-right">{{article.min_order|money}}</td>
<td>
  <button type="button" class="btn btn-success btn-sm" (click)="addArticle()" [disabled]="inList">
    Hinzufügen
  </button>
</td>
